module.exports = __webpack_public_path__ + "img/5.0a16bd73.png";